import { IonContent, IonPage } from '@ionic/react';
import { useEffect } from 'react';

import { Loading, Logo, Padding } from '@/components/common';
import { APP_STORE_URL } from '@/utils/constants';

const Ios: React.FC = () => {
  useEffect(() => {
    window.location.href = APP_STORE_URL;
  }, []);

  return (
    <IonPage id="ios">
      <IonContent>
        <Padding>
          <Logo />
          <Loading />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Ios;
